// eslint-disable-next-line import/prefer-default-export
export const setData = (key, value) => dispatch => {
  dispatch({
    type: "SET_DATA",
    payload: { key, value }
  });
};
export const setDropdown = (key, bool) => dispatch => {
  dispatch({
    type: "SET_Q_DROPDOWN",
    payload: { key, bool }
  });
};
export const closeDropdowns = () => dispatch => {
  dispatch({
    type: "CLOSE_DROPDOWNS",
    payload: true
  });
};
